import { useMemo } from "react";

/**
 * Compact month picker used on the Expenses / Bills pages. Builds its option
 * list from whatever months are actually present in `items` (plus the current
 * month, always). Newest month first. Values are "YYYY-MM".
 */
export default function MonthDropdown({ items, dateKey, value, onChange, testid }) {
  const options = useMemo(() => {
    const set = new Set();
    for (const r of items) {
      const ym = (r?.[dateKey] || "").slice(0, 7);
      if (ym) set.add(ym);
    }
    // Always include the current month so the picker isn't empty on a
    // fresh account with no entries yet.
    set.add(new Date().toISOString().slice(0, 7));
    const list = [...set].sort((a, b) => b.localeCompare(a));
    return list.map(ym => {
      const [y, m] = ym.split("-");
      const label = new Date(Number(y), Number(m) - 1, 1)
        .toLocaleString(undefined, { month: "long", year: "numeric" });
      return { value: ym, label };
    });
  }, [items, dateKey]);

  return (
    <select
      className="field-input"
      style={{ maxWidth: 220 }}
      value={value}
      onChange={e => onChange(e.target.value)}
      data-testid={testid}
    >
      {options.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
